<template>
	<v-navigation-drawer app v-model="drawer" color="#2A3042">
		<v-list-item class="py-5">
			<v-list-item-icon>
				<v-icon class="white--text" x-large>mdi-account-circle</v-icon>
			</v-list-item-icon>
			<v-list-item-title class="font-weight-bold white--text" v-model="name">{{ name }}</v-list-item-title>
		</v-list-item>

		<v-list nav>
			<v-list-item-group v-model="selectedItem" dark>
				<v-list-item v-for="(link, index) in links" :key="index" router :to="link.route">
					<v-list-item-icon>
						<v-icon class="white--text" v-text="link.icon"></v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title class="white--text" v-text="link.text"></v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list-item-group>
		</v-list>
		<template v-slot:append>
			<div class="pa-2" @click="logout()">
				<v-btn block class="black white--text">Logout</v-btn>
			</div>
		</template>
	</v-navigation-drawer>
</template>

<script>
	
    /**
     * @module Sidebar
     * 
	 * @vue-data {string} [name=''] - The user name 
	 * @vue-data {boolean|null} [drawer=null] - Toggle sidebar drawer
     * @vue-data {number} [selectedItem=0] - Sets the active list-item inside the list-group
     * @vue-data {array<object>} [links=[{ text: 'Dashboard', icon: 'mdi-view-dashboard', route: '/dashboard' }, { text: 'Data Warehouse', icon: 'mdi-database-search', route: '/search' }, { text: 'Settings', icon: 'mdi-account-cog', route: '/settings' }]] - Links with icon and route path  
	 */

	export default {
		name: 'Sidebar',
		data() {
			return {
				name: JSON.parse(localStorage.getItem('user')).name || '',
				drawer: null,
				selectedItem: 0,
				links: [
					{ text: 'Dashboard', icon: 'mdi-view-dashboard', route: '/dashboard' },
					{ text: 'Data Warehouse', icon: 'mdi-database-search', route: '/search' },
					{
						text: 'Settings',
						icon: 'mdi-account-cog',
						route: '/settings',
					},
				],
			};
		},
		methods: {
			logout() {
				localStorage.clear();
				this.$router.push({ path: '/login' });
			},
		},
	};
</script>
